<template>
  <footer>
    <div class="footer-main">
      <div class="nav logo">
        <nuxt-link to="/">
          <img class="logo-img" src="../assets/img/logo.png" alt="logo" width="180">
        </nuxt-link>
      </div>
      <div class="nav product">
        <h1>Products</h1>
        <ul class="nav-menu product-menu">
          <li class="nav-item" v-for="(product,index) in footerProducts" :key="index">
            <nuxt-link :to="product.url">
              {{ product.title }}
            </nuxt-link>
          </li>
        </ul>
      </div>
      <div class="nav navigation">
        <h1>Navigation</h1>
        <ul class="nav-menu">
          <li class="nav-item">
            <nuxt-link to="/about-us">
              About Us
            </nuxt-link>
          </li>
          <li class="nav-item">
            <nuxt-link to="/about-us/factory-production">
              Factory Production
            </nuxt-link>
          </li>
          <li class="nav-item">
            <nuxt-link to="/about-us/quality-control-ability">
              Quality Control Ability
            </nuxt-link>
          </li>
          <li class="nav-item">
            <nuxt-link to="/download">
              Download
            </nuxt-link>
          </li>
          <li class="nav-item">
            <nuxt-link to="/news">
              News
            </nuxt-link>
          </li>
          <li class="nav-item">
            <nuxt-link to="/about-us/faq">
              FAQ
            </nuxt-link>
          </li>
        </ul>
      </div>
      <div class="nav contact">
        <h1>Contact Us</h1>
        <ul class="nav-menu">
          <li class="nav-item">
            Telephone: 0086 (717) 6985355
          </li>
          <li class="nav-item">
            Fax: 0086 (717) 6985355
          </li>
          <li class="nav-item">
            Mobile: 0086 13657179347
          </li>
          <li class="nav-item">
            Whatsapp: 0086 13657179347
          </li>
          <li class="nav-item">
            <nuxt-link to="Skype:rch.intl?chat">
              Skype: rch.intl
            </nuxt-link>
          </li>
          <li class="nav-item">
            <nuxt-link to="mailto:info@rchintl.com">
              E-mail: info@rchintl.com
            </nuxt-link>
          </li>
          <li class="social-list">
            <nuxt-link to="https://www.facebook.com/profile.php?id=100090939108520" target="_blank" title="Facebook">
              <i class="iconfont icon-facebook" style="font-size: 25px"/>
            </nuxt-link>
            <nuxt-link to="https://twitter.com/RachelT36570346" target="_blank" title="Twitter">
              <i class="iconfont icon-tuite" style="font-size: 25px"/>
            </nuxt-link>
            <nuxt-link to="https://www.linkedin.com/in/rachel-tong-94381926a" target="_blank" title="Linkedin">
              <i class="iconfont icon-lingying" style="font-size: 25px"/>
            </nuxt-link>
            <nuxt-link to="https://www.youtube.com/channel/UCgZQv22pRmTKVTHvYlEOQKw" target="_blank" title="Youtube">
              <i class="iconfont icon-youtube" style="font-size: 25px"/>
            </nuxt-link>
            <nuxt-link to="Skype:rch.intl?chat" title="Skype">
              <i class="iconfont icon-skype" style="font-size: 25px"/>
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright">Copyright 2023 RCH Electronic | All Rights Reserved</div>
  </footer>
</template>
<script setup lang="ts">
import { footerProducts,nav } from '@/data/data'
import type { navItem } from '@/data/data'

// const productList = reactive<Array<navItem>>(footerProducts)

const navs = reactive<navItem[]>(nav.slice(1))
</script>

<style lang="stylus" scoped>
footer
  width 100%
  background #181818
  color: #FFF
  .footer-main
    text-align left
    max-width 1510px
    min-width 1280px
    height 100%
    margin auto
    padding 30px 50px 50px
    box-sizing border-box
    display flex
    .nav
      &>h1
        font-weight 600
        font-size 18px
      .nav-menu
        margin-top 30px
        .nav-item
          line-height 30px
          color #AAA
          &:hover>a
            color #1e8bac
        .social-list
          margin-top 8px
          &>a
            height: 30px
            width: 30px
            display inline-block
            line-height 30px
            text-align center
            transition .4s
            &:nth-child(1):hover
              background #37589b
              color #FFF
            &:nth-child(2):hover
              background #46d4fe
              color #FFF
            &:nth-child(3):hover
              background #419cca
              color #FFF
            &:nth-child(4):hover
              background #a72b1d
              color #FFF
            &:nth-child(5):hover
              background #12a5f4
              color #FFF
      .product-menu
        height 210px
        display flex
        flex-direction column
        flex-wrap wrap
    .logo
      flex 1
    .navigation
      flex 1
      padding-left 120px
    .product
      flex 1
      padding-left 60px
    .contact
      flex 1
      display flex
      flex-direction column
      align-items flex-start
  .copyright
    box-sizing border-box
    width 100%
    background #000
    padding 20px
    text-align center
    font-size 12px
</style>
